import React from "react";

export const DetailsMesuresCard = ({ heightPokemon, weigthPokemon }) => {
  const heightP = heightPokemon / 10;
  const weigthP = weigthPokemon / 10;
  return (
    <div className="details">
      <h2 className="height-poke">📏 Height</h2>
      <h2 className="weight-poke">⚖️ weight</h2>

      <button className="element-card">{heightP ? `${heightP}M` : "?"}</button>
      <button className="element-card">{weigthP ? `${weigthP} K` : "?"}</button>
    </div>
  );
};

export default DetailsMesuresCard;
